import { render } from "./DisaprovedComment.vue?vue&type=template&id=4050880c&scoped=true"
import script from "./DisaprovedComment.vue?vue&type=script&lang=js"
export * from "./DisaprovedComment.vue?vue&type=script&lang=js"

import "../css/DispositionRegistration.css?vue&type=style&index=0&id=4050880c&scoped=true&lang=css"
import "./DisaprovedComment.vue?vue&type=style&index=1&id=4050880c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Korisnik\\Desktop\\3. Semestar Mag\\VUI\\DiplomaInsight\\DiplomaInsight\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4050880c"]])

export default __exports__